module.exports = __webpack_public_path__ + "static/media/hintergrund.e01fc4da.jpg";